import { render, staticRenderFns } from "./defectList.vue?vue&type=template&id=ebd87e12"
import script from "./defectList.vue?vue&type=script&lang=js"
export * from "./defectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebd87e12')) {
      api.createRecord('ebd87e12', component.options)
    } else {
      api.reload('ebd87e12', component.options)
    }
    module.hot.accept("./defectList.vue?vue&type=template&id=ebd87e12", function () {
      api.rerender('ebd87e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/defect/defectList.vue"
export default component.exports